import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ReactComponent as Close } from '../../../../assets/images/teamclose.svg';
import { ListCoRoleName } from '../../../../store/features/ListCoUserByRole';
import { updateTicket } from '../../../../store/features/updateTicket';
import SearchInput from '../../../common/SearchInputField';
import { Avatar, Box, CircularProgress } from '@mui/material';
import { colorCodesForAvatar } from '../../../../constants/index';
import { chracterPosition } from '../../../../utils/index';
import NoSearch from '../../../common/NoSearch';

function AssignTicketPopup({ setAssignTicketPopup, ticketId, currentAssignee, onAssignSuccess }) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isAssigning, setIsAssigning] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const dispatch = useDispatch();

  const fetchAgents = async () => {
    try {
      const response = await dispatch(ListCoRoleName({ name: 'agent,admin,admin_with_billing' }));
      if (response.payload?.status === 200) {
        const filteredAgents = response.payload.data
          .filter(item => (!currentAssignee || item._id !== currentAssignee._id))
          .map(item => ({
            id: item._id,
            img: item.agent_image,
            name: item.full_name,
            email: item.email
          }));
        setData(filteredAgents);
        setFilteredData(filteredAgents);
      } else {
        toast.error('Failed to fetch agents');
      }
    } catch (error) {
      toast.error('Error fetching agents');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredResults = data.filter((row) =>
      row.name.toLowerCase().includes(query)
    );
    setFilteredData(filteredResults);
  };

  const handleAgentClick = (id) => {
    setSelectedAgent(id);
  };

  const handleAssignAgent = async () => {
    setIsAssigning(true);
    if (!selectedAgent) return;

    try {
      await dispatch(updateTicket({
        ticketId,
        updateData: { assignee: selectedAgent }
      })).unwrap();

      toast.success('Agent assigned successfully');
      onAssignSuccess();
      setAssignTicketPopup(false);
    } catch (error) {
      toast.error('Failed to assign agent');
    } finally {
      setIsAssigning(false);
    }
  };

  return (
    <>
      <div className="overlay" style={{ zIndex: 1 }} />
      <div className="Assign-PopUp-Container" >
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">Change Assignee</p>
          <p className="PopUp-Text02" onClick={() => setAssignTicketPopup(false)}>
            <Close />
          </p>
        </div>

        <div className="SearchChat-Popup">
          <SearchInput
            title=""
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchInputChange}
          />
        </div>
        {/* 
        {currentAssignee && (
          <>
            <div className="AgentsList">
              <div className="ChatPopup-Darleen-Container">
                <p>
                  {currentAssignee.agent_image ? (
                    <img
                      src={currentAssignee.agent_image}
                      alt="agent"
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        bgcolor: colorCodesForAvatar[
                          chracterPosition(
                            currentAssignee.full_name?.substring(0, 1).toUpperCase(),
                          )
                        ],
                      }}
                    >
                      {currentAssignee.full_name?.substring(0, 1).toUpperCase()}
                    </Avatar>
                  )}
                </p>
                <div>
                  <p className="Albert-text">{currentAssignee.full_name}</p>
                  <p className="No-activetext">Currently Assigned</p>
                </div>
              </div>
            </div>
            <hr style={{ backgroundColor: '#F1F3F5', height: '1px', border: 'none', margin: '16px 0' }} />
          </>
        )} */}

        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
            <CircularProgress />
          </Box>
        ) : filteredData.length === 0 ? (
          <NoSearch title="No agents found." description="Clear your search and try again." />
        ) : (
          <div style={{ maxHeight: '200px', overflowY: 'auto', padding: 0 }} className="AgentsList">

            {filteredData.map((item) => (
              <div

                className={`ChatPopup-Darleen-Container ${selectedAgent === item.id ? 'selected' : ''}`}
                key={item.id}
                onClick={() => handleAgentClick(item.id)}
              >
                <p>
                  {item.img ? (
                    <Avatar
                      src={item.img}
                      alt="agent"
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        bgcolor: colorCodesForAvatar[
                          chracterPosition(
                            item.name.substring(0, 1).toUpperCase(),
                          )
                        ],
                      }}
                    >
                      {item.name.substring(0, 1).toUpperCase()}
                    </Avatar>
                  )}
                </p>
                <div>
                  <p className="Albert-text">{item.name}</p>
                  <p style={{
                    color: '#405261',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '18px',
                  }}>{item.email}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="AssignTicket-footer">
          <button
            className="AddTansfer"
            style={{ minWidth: '112px' }}
            onClick={handleAssignAgent}
            disabled={!selectedAgent || isAssigning}
          >
            {isAssigning ? 'Applying...' : 'Apply'}
          </button>
        </div>
      </div>
    </>
  );
}

export default AssignTicketPopup; 